export const PROGRAMMATIC = "programmatic";
export const PROGRAMMATIC_TO_WRITTEN = "programmaticToWritten";
export const USER_GENERATED = "userGenerated";
export const WRITTEN = "written";
